import { ApplicationState } from 'application/redux';
import { close as closeModal, open as openModal } from 'core/modal/redux/actions';
import { connect } from 'react-redux';
import { hasPendingTasks } from '../../../../core/indicator/pending-tasks-redux';
import IdMappingCollisionComponent from './collision-mapping-component';
import {
  cancelIngest,
  clearPagination,
  execute,
  selectEntry,
  sendResolution
} from './redux/action';

const mapStateToProps = (state: ApplicationState) => ({
  application: state.application,
  results: state.management.idMapping.collision.results,
  isFetching: hasPendingTasks(state.pendingTasks),
  pageNumber: state.management.idMapping.collision.pageNumber,
  t: state.i18n.t
});
export default connect(mapStateToProps, {
  execute,
  selectEntry,
  sendResolution,
  clearPagination,
  openModal,
  closeModal,
  cancelIngest
})(IdMappingCollisionComponent);
